import { render, staticRenderFns } from "./doctor_animation_help.vue?vue&type=template&id=3a4c2d67&scoped=true"
var script = {}
import style0 from "./doctor_animation_help.vue?vue&type=style&index=0&id=3a4c2d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c2d67",
  null
  
)

export default component.exports